import React from "react";
import Popup from "reactjs-popup";

const Modalfunc = () => (
  <Popup
    trigger={<button className="button link-text"> Terms & Condition </button>}
    modal
    nested
  >
    {(close) => (
      <div className="modal">
        <button
          className="close w-fit absolute right-4 top-2 text-xl border px-2 bg-slate-400 rounded-2xl text-white"
          onClick={close}
        >
          &times;
        </button>
        <div className="header text-center font-bold">
          {" "}
          <u>Terms & Condition</u>
        </div>
        <br />
        <div className="content text-xs">
          <p className="font-semibold">
            I/We am/are aware that accepting this process is completely Optional
            and Voluntary, and I consent to do so to have access to a smooth
            trading platform.
          </p>
          <br />
          <p className="font-semibold">
            "Account" refers to the Trading/Demat account that the
            Client/Investor has with AGSL.
          </p>
          <br />
          <p className="font-semibold">
            “I/We” is considered an "Investor" or “Client” if they have a
            Trading/Demat account with Almondz.
          </p>
          <br />
          • I am aware that AGSL has gathered my cellphone number for the
          purpose of offering e-sign services and storing it for audit reasons.
          <br />
          • I also accept that after confirming my identification, AGSL would
          lead me to the website of NSDL for the purpose of issuing an
          eSign-based Aadhaar Number that I willfully submitted for the purpose
          of authenticating my identity during the procedure.
          <br />
          <br />
          <p className="font-semibold">
            In addition, I agree that you shall not be liable for any claim what
            so ever, or for any consequential, incidental, special, or exemplary
            damages, caused by the transfer/pledge/re-pledge/de-pledge of
            securities in accordance with this DDPI authorization for the
            following purposes:
          </p>
          <br />
          <p>
            1. Transfer of securities held in my/our accounts towards Stock
            Exchange-related deliveries/settlement obligations arising out of
            trades executed by me/our on the Stock Exchange through the Almondz.
          </p>
          <br />
          <p>
            2. The pledging or re-pledging of securities in favor of a trading
            member (TM) or a clearing member (CM) for the purpose of fulfilling
            margin requirements in connection with transactions that I/We
            completed on the stock exchange; these requirements are related to
            the trades that I/We conducted on the stock exchange.
          </p>
          <br />
          <p>
            3. Transactions involving mutual funds are carried out on the order
            entry systems of stock exchanges.
          </p>
          <br/>
          <p>
            4. Participating in open offers for shares by using the various
            platforms provided by stock exchanges.
          </p>
          <br />
          <br />
          <p className="font-semibold">
            I/We hereby provide my absolute permission and authorize AGSL to
            process my fully filled "DDPI" with all the Legality.
          </p>
        </div>
        {/* <div className="actions">
          <Popup
            trigger={<button className="button"></button>}
            position="top center"
            nested
          >
          </Popup>
          <button
            className="button"
            onClick={() => {
              console.log("modal closed ");
              close();
            }}
          >
          </button>
        </div> */}
      </div>
    )}
  </Popup>
);
export default Modalfunc;
